module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAhUlEQVQ4jdWTQQ5DIQhEZxruVW8G3AxPNl395mtMU2M3ZQXKmzAGKQkn8TiifyFgV5KZ217cnXbBrbUtuKpAUpaZcvctODPfuQFA7/0r8NkaetVwZqvGmpouezM8CNyhiBia7vX8Vra6mJfrk0VbjTzXq4gISCIlgeT2DkgiAPD//8KxwAuAiDytpR8ThQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/walleris/images/ADRIVE_16.png
// module id = 41
// module chunks = 0